export const ALERTS_APPLY_FILTERS_BUTTON_WIDTH_PX = 120;
export const ALERTS_FILTER_FIELD_MIN_WIDTH_PX = 140;
export const ALERTS_FILTER_DATE_MIN_WIDTH_PX = 150;
export const ALERTS_FILTER_FIELD_GAP_PX = 12;
export const ALERTS_FILTER_FIELD_COUNT = 3;
export const ALERTS_FILTER_DATE_FIELD_COUNT = 4;

export const ALERTS_FILTER_HORIZONTAL_PADDING_PX = 32;

export const ALERTS_FILTER_FIELDS_MIN_ROW_WIDTH_PX =
  ALERTS_FILTER_FIELD_MIN_WIDTH_PX * ALERTS_FILTER_FIELD_COUNT +
  ALERTS_FILTER_DATE_MIN_WIDTH_PX * ALERTS_FILTER_DATE_FIELD_COUNT +
  ALERTS_FILTER_FIELD_GAP_PX *
    (ALERTS_FILTER_FIELD_COUNT + ALERTS_FILTER_DATE_FIELD_COUNT - 1);

export const ALERTS_FILTER_STACK_BREAKPOINT_PX =
  ALERTS_FILTER_FIELDS_MIN_ROW_WIDTH_PX +
  ALERTS_FILTER_FIELD_GAP_PX +
  ALERTS_APPLY_FILTERS_BUTTON_WIDTH_PX +
  ALERTS_FILTER_HORIZONTAL_PADDING_PX;

export const shouldStackAlertsFilters = (containerWidth: number) =>
  containerWidth > 0 && containerWidth < ALERTS_FILTER_STACK_BREAKPOINT_PX;

export const alertsFilterFieldClassName = "min-w-[140px] flex-1";
export const alertsFilterDateFieldClassName = "min-w-[150px] flex-1";
export const alertsFilterFieldStackedClassName = "w-[140px] min-w-[140px]";
export const alertsFilterDateFieldStackedClassName = "w-[150px] min-w-[150px]";
export const alertsFilterFieldsRowClassName =
  "flex min-w-0 w-full flex-1 items-end gap-3";
export const alertsFilterFieldsStackedClassName =
  "flex w-full flex-wrap items-end gap-3";

export const alertsFilterControlSx = {
  width: "100%",
  minWidth: 0,
} as const;

export const ALERTS_TABLE_FILTER_MIN_WIDTH_PX = 100;
export const alertsTableFilterFieldClassName = `min-w-[${ALERTS_TABLE_FILTER_MIN_WIDTH_PX}px] flex-1`;
export const alertsTableFilterRowClassName =
  "flex min-w-0 flex-1 flex-wrap items-start gap-x-2 gap-y-2";

export const alertsTableFilterControlSx = {
  ...alertsFilterControlSx,
  fontFamily: "Mulish",
  "& .MuiInputLabel-root": { fontFamily: "Mulish" },
  "& .MuiOutlinedInput-root": { fontFamily: "Mulish" },
} as const;

/**
 * Multi-select filters (Parent Group / Site / Camera). MUI forces the input
 * root to wrap for `multiple`, and at the filter's 140px minimum a chip plus
 * the 30px text input plus the clear/popup icons never fit, so a single
 * selected site was pushing the input onto a second row and the field grew
 * to twice its height. Keep it on one line while idle (chip truncates with an
 * ellipsis, "+N" stays intact) and only wrap while focused so every chip is
 * reachable for removal.
 */
export const alertsFilterMultiSelectSx = {
  ...alertsFilterControlSx,
  "& .MuiAutocomplete-inputRoot:not(.Mui-focused)": {
    flexWrap: "nowrap",
    "& .MuiAutocomplete-input": { minWidth: 0 },
  },
  "& .MuiChip-root.MuiAutocomplete-tag": { minWidth: 0 },
  "& span.MuiAutocomplete-tag": { flexShrink: 0 },
} as const;

/**
 * Date / time filter fields. Chrome paints an input light blue when it fills
 * the value itself (including when the user picks a previously typed date from
 * its suggestion dropdown) and keeps it that way, so the fields looked stuck in
 * a highlighted state. Paint over that tint; the pickers also send
 * autoComplete="off" so the suggestions don't appear in the first place.
 */
export const alertsFilterDateControlSx = {
  ...alertsFilterControlSx,
  "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus":
    {
      WebkitBoxShadow: "0 0 0 1000px #fff inset",
      WebkitTextFillColor: "inherit",
      caretColor: "inherit",
    },
} as const;

export const alertsApplyFiltersButtonClassName =
  "shadow-button shrink-0 border-2 border-actuate-orange bg-actuate-orange p-1.5 font-mulish text-base text-white rounded w-[120px] hover:bg-[#E67300]";
